import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import authService from './services/authService';
import bedrockService from './services/bedrockService';
import './App.css';

// Configure these from your CDK stack outputs (AgentParent user pool and identity pool)
const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || 'us-east-1_GDJnw33zH';
const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID || '1eb576adtr94r6iiflaldcsmov';
const IDENTITY_POOL_ID = process.env.REACT_APP_IDENTITY_POOL_ID || 'your-identity-pool-id';
const AGENT_PARENT_API_URL = process.env.REACT_APP_AGENT_PARENT_API_URL || 'https://at27a85sn4.execute-api.us-east-1.amazonaws.com/prod';
const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authResult, setAuthResult] = useState(null);
  const [isConfigured, setIsConfigured] = useState(false);

  // Configure Amplify and Bedrock on app startup and check for existing session
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        authService.configure(USER_POOL_ID, USER_POOL_CLIENT_ID, AWS_REGION);
        
        // Fetch the authenticated role ARN from the config endpoint
        const configResponse = await fetch(`${AGENT_PARENT_API_URL}/config`);
        const config = await configResponse.json();
        const authenticatedRoleArn = config.authenticatedRoleArn;
        
        bedrockService.configure(IDENTITY_POOL_ID, AWS_REGION, USER_POOL_ID, authenticatedRoleArn);
        setIsConfigured(true);
        console.log('Amplify and Bedrock configured successfully');

        // Check if there's an existing authenticated session
        try {
          const session = await authService.getCurrentSession();
          if (session && session.tokens) {
            const accessToken = session.tokens?.accessToken?.toString();
            setAuthResult({ accessToken });
            setIsAuthenticated(true);
            console.log('Found existing authenticated session');
          }
        } catch (err) {
          // No existing session, user needs to sign in
          console.log('No existing session found');
        }
      } catch (error) {
        console.error('Error configuring Amplify:', error);
      }
    };

    initializeAuth();
  }, []);

  const handleLogin = (result) => {
    setAuthResult(result);
    setIsAuthenticated(true);
  };

  const handleSignOut = async () => {
    try {
      await authService.signOut();
      setIsAuthenticated(false);
      setAuthResult(null);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (!isConfigured) {
    return (
      <div className="App">
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Loading...</h2>
          <p>Configuring authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        <Dashboard authResult={authResult} onSignOut={handleSignOut} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
